import { render, staticRenderFns } from "./PunchInOutModal.vue?vue&type=template&id=4ef4807a&scoped=true&"
import script from "./PunchInOutModal.vue?vue&type=script&lang=js&"
export * from "./PunchInOutModal.vue?vue&type=script&lang=js&"
import style0 from "./PunchInOutModal.vue?vue&type=style&index=0&id=4ef4807a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef4807a",
  null
  
)

export default component.exports